<template>
  <div>
    <Breadcrumbs :classes="{ booking_time: true }"/>
    <div class="text-center m-5 menu_explain-booking px-8">{{ this.permalinkData.clinic_basic_setting.note_date_and_time }}</div>
    <div class="container-fluid step-customer-booking">
      <div class="row select-therapist_wrapper">
        <div class="col-xs-12 font-hiraginoSans-w3">
          <p class="text-therapist">ご指名がある場合担当者を選択してください</p>
          <p class="text-therapist mb-3">予約のカレンダーが切り替わります</p>
          <v-select
            v-model="currentTab"
            :options="availableTherapists"
            placeholder="担当者"
            @input="setTab"
            label="name"
            :reduce="reduceTherapist"
            :clearable="false"
            :searchable="true"
            class="mb-5 select-therapist"
          >
            <template #no-options>
              <div class="text-left">対象が見つかりません</div>
            </template>
          </v-select>
          <div v-if="selectedTherapist && currentTab !== null" class="therapist-info mb-5">
            <div class="therapist-img-booking mb-3 mr-4">
              <img
                  :src="selectedTherapist.image && selectedTherapist.image.url ? selectedTherapist.image.url : '/images/user-chat.png'"
                  :alt="selectedTherapist.name"
                  :title="selectedTherapist.name"
                  class="therapist-img"
              />
            </div>
            <div class="text-therapist-booking">
              {{ selectedTherapist ? selectedTherapist.catch_copy : '' }}
            </div>
          </div>
          <p class="mb-5 text-therapist">ご希望の日時を選択してください。</p>
        </div>
      </div>
    </div>
    <div class="container-fluid step-customer-booking">
      <div class="row m-1">
        <Calendar
            ref="calendarComponent"
            :therapist="selectedTherapist"
            :currentCustomer="currentCustomer"
            @eventSelected="handleEventSelected"
            @showCustomerInfo="switchToCustomerInfo"
        />
      </div>
    </div>
    <div class="footer-wrapper py-5">
      <div class="container">
        <div class="footer-buttons">
          <span class="back-step" @click="goBack">&lt; 戻る</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from './Breadcrumbs.vue';
import {mapActions, mapGetters} from 'vuex';
import Calendar from './Calendar.vue';

export default {
  name: 'ChooseTherapist',
  components: {
    Breadcrumbs,
    Calendar
  },
  props: {
    selectedTimeprice: {
      type: Object,
      required: true
    },
    currentCustomer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentTab: null,
      selectedStartDate: null,
      selectedEndDate: null
    };
  },
  computed: {
    ...mapGetters('permalink', ['timepriceTherapists', 'therapists', 'selectedTherapist', 'permalinkData']),
    availableTherapists() {
      if (this.permalinkData.show_therapist_booking) {
        return [
          { id: null, name: '指名なし' },
          ...this.timepriceTherapists
        ];
      } else {
        return [{ id: null, name: '指名なし' }];
      }
    }
  },
  methods: {
    ...mapActions('permalink', ['fetchTimepriceData', 'setSelectedTherapist']),
    setTab(tab) {
      console.log('Selected therapist:', tab);
      this.currentTab = tab;
      const therapist = this.availableTherapists.find(therapist => therapist.id === tab) || null;
      this.setSelectedTherapist(therapist);
      this.reloadCalendar();
    },
    reloadCalendar() {
      this.$refs.calendarComponent.loadEvents();
    },
    chooseTherapist(therapist) {
      this.$emit('showCalendar', therapist.id);
    },
    goBack() {
      this.$emit('goBack');
    },
    handleEventSelected({startDate, endDate}) {
      this.selectedStartDate = startDate;
      this.selectedEndDate = endDate;
      this.$emit('eventSelected', {startDate, endDate});
    },
    switchToCustomerInfo() {
      this.$emit('showCustomerInfo');
      this.currentComponent = 'CustomerInfo';
    },
    reduceTherapist(therapist) {
      return therapist.id;
    }
  },
  mounted() {
    if (this.selectedTimeprice && this.selectedTimeprice.id) {
      this.fetchTimepriceData(this.selectedTimeprice.id);
    }
    if (this.selectedTherapist) {
      this.currentTab = this.selectedTherapist.id;
    } else {
      this.currentTab = null;
    }
  }
};
</script>

<style scoped>
.footer-form-mobile {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
}

.button-back a {
  color: #070807;
  text-decoration: none;
  font-weight: bold;
}

.mt-3 {
  margin-top: 1rem;
}

.select-group {
  margin-bottom: 20px;
}

.select-group select {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  font-size: 16px;
  font-weight: bold;
  background-color: #f0f0f0;
}

.therapist-info {
  display: flex;
  align-items: center;
  margin-top: 1rem;
}

.therapist-img {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: block;
}

.text-therapist-booking {
  font-family: HiraginoSans-W3;
  font-size: 14px;
  color: #00122E;
  flex: 1;
}

.select-therapist {
  width: 50%;
  .vs__dropdown-toggle {
    height: unset;
  }
}

@media (max-width: 768px) {
  .therapist-info {
    flex-direction: column;
    align-items: center;
  }

  .therapist-img-booking {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .therapist-info {
    flex-direction: row;
    align-items: center;
  }

  .therapist-img-booking {
    margin-right: 1rem;
    margin-bottom: 1rem;
  }

  .text-therapist-booking {
    text-align: left;
  }

  .select-therapist {
    width: 100%;
  }

  .select-therapist_wrapper {
    &.row {
      margin-left: -15px !important;
      margin-right: -15px !important;;
    }
  }
}
</style>